import { TypedDocumentNode, gql } from '@apollo/client';

export interface UpdateErpSystemMutationVariables {
  id: number;
  input: { erp_system: string | null };
}

export const updateErpSystemMutation = gql`
  mutation UpdateErpSystem($id: bigint!, $input: orders_companies_set_input!) {
    update_orders_companies_by_pk(pk_columns: { id: $id }, _set: $input) {
      erp_system
    }
  }
` as TypedDocumentNode<unknown, UpdateErpSystemMutationVariables>;
